import React, { useEffect } from "react";
import { useEyeconxStore } from "../../../store/eyeconxStore";
import clinicService from "../../../services/clinic.service";
import { useNavigate,Link } from "react-router-dom";


/*
*  User Clinic Number to be asked to Yash
* */
function EcxOffcanvas({ show, handleClose }) {
  const userInfo = useEyeconxStore((state) => state.userInfo);
  const setUserInfo = useEyeconxStore((state) => state.setUserInfo);
  const logout = useEyeconxStore((state) => state.logout);
  const user = useEyeconxStore((state) => state.user);

  const navigate = useNavigate();

  useEffect(() => {
    if (userInfo === null) {
      getUserInfo();
    }
  }, []);

  const getUserInfo = () => {
    clinicService
      .getUserInfo(user.clinicId, user.ID)
      .then((res) => setUserInfo(res.data))
      .catch((err) =>
      {
        //console.log(err)
      });
  };

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  return (
    <div
      className={`offcanvas offcanvas-end ${show ? "show" : ""}`}
      tabIndex="-1"
      style={{ visibility: show ? "visible" : "hidden" }}
    >
      {/* Header */}
      <div className="offcanvas-header">
        <h5 className="offcanvas-title">User Settings</h5>
        <button
          type="button"
          className="btn-close"
          aria-label="Close"
          onClick={handleClose}
        ></button>
      </div>

      {/* Body */}
      <div className="offcanvas-body">

          <>
            {/* User Info */}
            <div className="d-flex flex-column">
              <span className="fw-bold fs-4 mb-2">
                {userInfo?.firstName} {userInfo?.lastName}
              </span>
              <span className="fs-6 mb-2 text-muted">
                <i className="bi bi-person me-2"></i> {userInfo?.userName}
              </span>
              <span className="fs-6 mb-4 text-muted">
                <i className="bi bi-envelope me-2"></i> {userInfo?.email}
              </span>
            </div>

            {/* Logout */}
            <button className="btn btn-outline-danger w-100 mb-4" onClick={handleLogout}>
              <i className="bi bi-box-arrow-right me-2"></i> Sign out
            </button>

            <hr />

            {/* Settings links */}
            <div className="d-flex flex-column gap-3">

              <Link
                  to="/update-password"
                  className="btn btn-light-primary border-0 d-flex align-items-center p-3 w-100 text-start text-dark text-decoration-none"
                  style={{ cursor: "pointer" }}
              >
                <i className="bi bi-shield-lock fs-3 me-3"></i>
                <div>
                  <h6 className="mb-1 mb-0 fw-semibold text-dark">Password Settings</h6>
                  <small className="text-muted">Change your password</small>
                </div>
              </Link>
              <Link
                  to="/activity"
                  className="btn btn-info d-flex align-items-center p-3 w-100 text-start text-white text-decoration-none"
                  style={{ cursor: "pointer" }}
              >
                <i className="bi bi-activity fs-3 me-3"></i>
                <div>
                  <h6 className="mb-1 mb-0 fw-semibold text-white">My Activities</h6>
                  <small className="text-muted">Logs and Notifications</small>
                </div>
              </Link>

            </div>
          </>
      </div>
    </div>
  );
}

export default EcxOffcanvas;
